import { logger } from "@/services/loggerService";
/** Manages module registration and exposes aggregated module capabilities. */
class ModuleRegistry {
    constructor() {
        Object.defineProperty(this, "modules", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    initialize(contracts) {
        this.contracts = contracts;
    }
    registerModule(module) {
        if (!this.contracts) {
            throw new Error("ModuleRegistry not initialized. Call initialize() first.");
        }
        const registration = module.register(this.contracts);
        this.modules.set(registration.id, module);
        logger.debug(`[ModuleRegistry] Registered module: ${registration.name}`);
    }
    getModuleRoutes() {
        const routes = [];
        for (const [id, module] of this.modules) {
            try {
                const moduleRoutes = module.getRoutes();
                routes.push(...moduleRoutes);
                logger.debug(`[ModuleRegistry] Loaded ${moduleRoutes.length} routes from module: ${id}`);
            }
            catch (error) {
                logger.debug(`[ModuleRegistry] Failed to get routes from module ${id}:`, { error });
            }
        }
        return routes;
    }
    getNavigationItems() {
        const items = [];
        for (const [id, module] of this.modules) {
            try {
                items.push(...module.getNavigationItems());
            }
            catch (error) {
                logger.debug(`[ModuleRegistry] Failed to get navigation items from module ${id}:`, { error });
            }
        }
        return items;
    }
    getComponentForSlot(slotName) {
        for (const [, module] of this.modules) {
            if (module.getComponent) {
                const component = module.getComponent(slotName);
                if (component) {
                    return component;
                }
            }
        }
        return null;
    }
    unregisterAll() {
        for (const [, module] of this.modules) {
            if (module.unregister) {
                module.unregister();
            }
        }
        this.modules.clear();
        this.contracts = null;
    }
}
export const moduleRegistry = new ModuleRegistry();
